import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB3P5TMGAAusanBtPXSjH0HmGZ8VOuX0z0",
  authDomain: "circana-3bf6e.firebaseapp.com",
  projectId: "circana-3bf6e",
  storageBucket: "circana-3bf6e.firebasestorage.app",
  messagingSenderId: "508422955324",
  appId: "1:508422955324:web:2f7fe2941dff300f5c7e39",
  measurementId: "G-N6JSJZZRZR" // Optional: for Analytics
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Expose for debugging in browser console (non-production usage)
if (typeof window !== 'undefined') {
  window.firebaseAppInstance = app;
  window.firebaseAuth = auth;
  window.firebaseDb = db;
}

// Export the app instance
export default app;

